<template>
    <div>
        <div>
            <LoadingSpinner loading class="spinner"/>
        </div>
        <div>
            <p class="loader--ellipsis"></p>
        </div>
    </div>
</template>

<script>
import LoadingSpinner from '../../app/bookingservice/v4/components/Global/LoadingSpinner.vue';

export default {
  name: 'PaymentLoadingState',
  components: { LoadingSpinner },
  data() {
    return {
      spinner: 'fas fa-circle-notch fa-spin',
    };
  },
};
</script>

<style scoped>
    .loader--ellipsis {
        font-size: 1rem;
        font-family: 'M PLUS Rounded 1c', sans-serif;
        letter-spacing: 1px;
        text-align: center;
        padding-left: 30px;
    }

    .loader--ellipsis:after {
        content: "Loading, please wait\00a0\00a0\00a0";
        animation-name: loading-ellipsis;
        animation-duration: 3s;
        animation-iteration-count: infinite;
    }

    @keyframes loading-ellipsis {
        0% {
            content: "Loading, please wait\00a0\00a0\00a0";
        }
        25% {
            content: "Loading, please wait.\00a0\00a0";
        }
        50% {
            content: "Loading, please wait..\00a0";
        }
        75% {
            content: "Loading, please wait...";
        }
    }

    .spinner {
        max-height: 100px;
        filter: unset;
        background-color: unset;
    }
</style>
